import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

import { wasDateMoreThanSomeMinutesAgo } from 'app/utils/dateTimeUtils'
import { userHasFunctionality } from 'app/utils/userUtils'
import { getJobs, getJob, startJob, updateJob } from 'app/gears/admin/jobs/actions/jobActions'
import JobsSummary from 'app/gears/admin/jobs/components/JobsSummary'
import JobSummary from 'app/gears/admin/jobs/components/JobSummary'
import JobRun from 'app/gears/admin/jobs/components/JobRun'
import LgyLoadingFallback from 'app/components/util/lgy-loading-fallback/LgyLoadingFallback'

const JobsContainer = ({ match, jobs, getJobs, getJob, startJob, isError, isLoading, fetchedDate, userCanStartJobs, isStartingNewJob, updateJob }) => {
  useEffect(() => {
    if (!fetchedDate || wasDateMoreThanSomeMinutesAgo(fetchedDate, 5)) {
      getJobs && getJobs()
    }
  }, [fetchedDate, getJobs])

  useEffect(() => {
    if (jobs.length > 0 && match.params.jobName !== undefined) {
      getJob(match.params.jobName)
    }
  }, [jobs, getJob, match.params.jobName])

  return <LgyLoadingFallback isLoading={isLoading} isError={isError}>
    <Switch>
      <Route exact path='/lgyhub/admin/jobs' render={() => <JobsSummary jobs={jobs} />} />
      <Route exact path='/lgyhub/admin/jobs/:jobName?' render={() => <JobSummary job={jobs.find(job => job.name === match.params.jobName)} startJob={startJob} userCanStartJobs={userCanStartJobs} isStartingNewJob={isStartingNewJob} updateJob={updateJob}/>} />
      <Route exact path='/lgyhub/admin/jobs/:jobName/:runId/' render={({ match }) =>
        <JobRun jobName={match.params.jobName} run={jobs.find(job => job.name === match.params.jobName).runs.find(run => run.id === parseInt(match.params.runId))} />} />
    </Switch>
  </LgyLoadingFallback>
}

const mapStateToProps = (state) => ({
  ...state.jobState,
  userCanStartJobs: userHasFunctionality(state.currentUser, 'Run Jobs')
})

const mapDispatchToProps = { getJobs, getJob, startJob, updateJob }

export default connect(mapStateToProps, mapDispatchToProps)(JobsContainer)
